import { forwardRef } from 'react';

import { isIOS, isSafari } from '@rikstv/play-common/src/utils/device/device.utils';

import styles from './SwimlanePlaceholder.module.css';

// React 18 does not type `inert` and drops `inert={true}` with a warning, so the boolean
// attribute is written as an empty string. Replace with a plain `inert` prop on React 19.
const inertAttribute = { inert: '' } as unknown as { inert?: boolean };

export const SwimlanePlaceholder = forwardRef<
  HTMLDivElement,
  { active: boolean; animationDelay?: number; children?: React.ReactNode }
>(({ active, animationDelay = 0, children }, ref) => {
  const isApple = isIOS || isSafari;

  if (active) {
    return (
      <div className={styles.commonPageSwimlanePlaceholder} aria-busy="true">
        <p className="sr-only">Laster inn karusell</p>
        <div
          ref={ref}
          {...inertAttribute}
          className={styles.commonPageSwimlanePlaceholderContent}
          style={{
            animationDelay: `${animationDelay * 75}ms`,
            //set animationIterationCount = 0 for apple because of performance issues
            animationIterationCount: isApple ? '0' : 'infinite',
          }}>
          {children}
        </div>
      </div>
    );
  }

  return <>{children}</>;
});
